exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active[data-v-367958ee] {\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n}\n.slide-leave-active[data-v-367958ee] {\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n}\n.slide-enter-to[data-v-367958ee], .slide-leave[data-v-367958ee] {\n  max-height: 40rem;\n  overflow: hidden;\n}\n.slide-enter[data-v-367958ee], .slide-leave-to[data-v-367958ee] {\n  max-height: 0;\n  overflow: hidden;\n}", ""]);

// exports
